export default __webpack_public_path__ + "static/media/downArrowForMenu.f2799494.svg";